import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const PlaybooksEmptyMessage = ({
  query
}) => {
  const messageType = query === '' ? 'noPlaybooksCreated' : 'search';
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "100",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `cardPlaybooks.playbooksIndex.emptyState.${messageType}`
    })
  });
};
PlaybooksEmptyMessage.propTypes = {
  query: PropTypes.string
};
export default PlaybooksEmptyMessage;